import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { useNavigate, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getUnreadCount } from '../../services/notifications';
import { Bell, Zap, MapPin, Sun, Moon } from 'lucide-react';

export default function Header() {
    const { user, logout } = useAuth();
    const { dark, toggle } = useTheme();
    const navigate = useNavigate();
    const [unread, setUnread] = useState(0);

    useEffect(() => {
        getUnreadCount().then(r => setUnread(r.data.count)).catch(() => {});
        const interval = setInterval(() => {
            getUnreadCount().then(r => setUnread(r.data.count)).catch(() => {});
        }, 30000);
        return () => clearInterval(interval);
    }, []);

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <header className="fixed top-0 left-64 right-0 h-16 bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl border-b border-gray-200 dark:border-gray-700 z-30 flex items-center justify-between px-6">
            <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                <MapPin className="w-4 h-4" />
                <span className="capitalize">{user?.role === 'teacher' ? "O'qituvchi" : user?.role === 'admin' ? 'Admin' : 'Talaba'} paneli</span>
            </div>
            <div className="flex items-center gap-4">
                {/* Theme toggle */}
                <button onClick={toggle} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition" title={dark ? 'Kunduzgi rejim' : 'Tungi rejim'}>
                    {dark ? <Sun className="w-5 h-5 text-yellow-400" /> : <Moon className="w-5 h-5 text-gray-600" />}
                </button>

                {/* Notifications */}
                <Link to="/notifications" className="relative p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition">
                    <Bell className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                    {unread > 0 && (
                        <span className="absolute top-1 right-1 w-4 h-4 bg-red-500 text-white rounded-full text-[10px] flex items-center justify-center font-bold">{unread > 9 ? '9+' : unread}</span>
                    )}
                </Link>

                {/* XP for students */}
                {user?.role === 'student' && (
                    <div className="flex items-center gap-1 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 px-3 py-1.5 rounded-lg text-sm font-medium">
                        <Zap className="w-4 h-4" /><span>{user?.xp_points || 0} XP</span>
                    </div>
                )}

                {/* Profile */}
                <Link to="/profile" className="flex items-center gap-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-xl px-3 py-1.5 transition">
                    <div className="text-right">
                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{user?.name}</p>
                        <p className="text-xs text-gray-500 dark:text-gray-400 capitalize">{user?.role}</p>
                    </div>
                    <div className="w-9 h-9 rounded-xl bg-gradient-to-r from-blue-500 to-purple-600 text-white flex items-center justify-center text-sm font-bold">
                        {user?.name?.charAt(0)?.toUpperCase()}
                    </div>
                </Link>

                <button onClick={handleLogout} className="px-4 py-2 text-sm text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-xl transition font-medium">
                    Chiqish
                </button>
            </div>
        </header>
    );
}